import { IrisQueryParamsBuilder } from '@iris/api-query';
import { IrisDeviceI } from '@iris/common/models/IrisDevice';
import { IrisDevicesService } from '@iris/common/services/devices/devices.service';
import { IrisFilterDefaultChipItemViewComponent } from '@iris/modules/module-filters-v2/chips/default-chip-item-view.component';
import { isObject } from 'lodash';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { ComponentRef } from '@angular/core';

type Device = IrisDeviceI | IrisDeviceI['id'];

export const DEVICE_CHIP_RENDERING_OPTIONS: IrisFilterChipRenderingOptions<IrisFilterDefaultChipItemViewComponent, Device> = {
  component: IrisFilterDefaultChipItemViewComponent,
  initComponentFn: (componentRef: ComponentRef<IrisFilterDefaultChipItemViewComponent>, device, injector) => {
    const component = componentRef.instance;
    const service = injector.get(IrisDevicesService);
    const id = isObject(device) ? device.id : device;
    const params = new IrisQueryParamsBuilder().onlyFields(['name']).toStructure();

    component.text$ = service.getById(id, params)
      .pipe(
        map(entity => entity.name),
        publishReplay(1),
        refCount(),
      );
  },
};
